import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import Lottie from 'lottie-web'

import fragmentShader from '../shaders/tree/fragment.glsl'
import vertexShader from '../shaders/tree/vertex.glsl'

import EventEmitter from './EventEmitter.js'

export default class Resources extends EventEmitter {
  constructor (sources) {
    super()

    this.sources = sources

    this.items = {}
    this.toLoad = this.sources.length
    this.loaded = 0
    this.loader = document.getElementsByClassName('loader')
    this.pourcentage = document.getElementById('pourcentage')

    this.setLoaders()
    this.startLoading()
  }

  setLoaders () {
    this.loadingManager = new THREE.LoadingManager(
      // Loaded
      () => {
        this.loader[0].style.display = 'none'
      },
      (itemUrl, itemsLoaded, itemsTotal) => {
        const progressRatio = itemsLoaded / itemsTotal
        this.pourcentage.innerHTML = `${Math.floor(progressRatio * 100)}%`

        // Lottie.loadAnimation({
        //   container: this.loader, // the dom element that will contain the animation
        //   renderer: 'svg',
        //   loop: true,
        //   autoplay: true,
        //   path: './videos/FlowerLoader.json', // the path to the animation json
        // });
        // console.log(anim)
      }
    )

    this.loaders = {}
    this.loaders.gltfLoader = new GLTFLoader(this.loadingManager)
    this.loaders.textureLoader = new THREE.TextureLoader(this.loadingManager)
    this.loaders.cubeTextureLoader = new THREE.CubeTextureLoader(
      this.loadingManager
    )
  }

  startLoading () {
    // Load each source
    for (const source of this.sources) {
      if (source.type === 'gltfModel') {
        this.loaders.gltfLoader.load(source.path, (file) => {
          this.sourceLoaded(source, file)
        })
      } else if (source.type === 'texture') {
        this.loaders.textureLoader.load(source.path, (file) => {
          this.sourceLoaded(source, file)
        })
      } else if (source.type === 'cubeTexture') {
        this.loaders.cubeTextureLoader.load(source.path, (file) => {
          this.sourceLoaded(source, file)
        })
      }
    }
  }

  sourceLoaded (source, file) {
    this.items[source.name] = file

    this.loaded++

    if (this.loaded === this.toLoad) this.trigger('ready')
  }
}
